export const truBrokerCriteriaIcons = {
  'active-listings-gt-4': {
    icon: 'ListIcon',
  },
  'avg-listing-health-gt-50': {
    icon: 'ProgressIcon',
  },
  'upgrade-to-hot': {
    icon: 'HotListingTrubroker',
    iconColor: '#f73131',
  },
  'upgrade-to-signature': {
    icon: 'SignatureListingTruBroker',
    iconColor: '#af6fff',
  },
  'post-a-listing': {
    icon: 'LocationIcon',
  },
  'trubroker-3-months': {
    icon: 'TruBrokerThreeMonths',
  },
  'trubroker-6-months': {
    icon: 'TruBrokerSixMonths',
  },
  'activate-trucheck-rented': {
    icon: 'RentalProperty',
  },
  'activate-trucheck-sale': {
    icon: 'HouseIcon',
  },
};
